// 用户存和快递存，选择方法
<template>
  <div class="selectWay">
    <!-- 流程 -->
    <userSaveFlow :index="1"></userSaveFlow>
    <div class="way-list clearfix">
      <div class="flex">
        <div class="list clearfix">
          <p class="title">方法1：请刷员工卡</p>
          <div class="detail">
            <div class="left-bracket"></div>
            <div class="img card"><img src="../../../../static/images/icon4.png" alt=""></div>
            <div class="right-bracket"></div> 
          </div>
        </div>

        <div class="list clearfix">
          <p class="title">方法2：打开微信扫二维码</p>
          <div class="detail">
            <div class="left-bracket"></div>
            <div class="img code">
              <span
                class="text"
                v-show="QRurl === ''">二维码获取中...</span>
              <img
                :src="QRurl"
                v-show="QRurl !== ''" />
            </div>
            <div class="right-bracket"></div>
          </div>
        </div>
      </div> 
    </div>

    <!-- 上一步 -->
    <span class="turnoverCabinet-btn-back" v-show="$store.state.isShowRBot" @click="back">上一步</span>
    <!-- mqtt -->
    <mqttws ref="mqttws" @getMessage="getMessage"></mqttws> 
  </div>
</template>

<script>
import mqttws from '../../../assets/mqttws2'
// import mqttws from '../../../assets/mqttws2_4.0s'
import userSaveFlow from '../userSave/userSaveFlow'
import { cabinetApi } from "../../../../static/turnoverCabinet/js/api.js"
import { showLoading, hideLoading, showToast, storage } from '../../../../static/turnoverCabinet/js/utility'

let timeout
export default {
  name: 'selectWay',
  components: {
    userSaveFlow,
    mqttws
  },
  data () {
    return {
      cardNum: '',
      QRurl: '',
      authID: ''
    }
  },
  created () {
    console.log('type', this.$store.state.type, this.$store.state.company_id)
    this.getQRCode()
    // this.getStoreLoginInfo()
  },
  mounted () {
  },
  // 页面销毁后
  destroyed () {
    // 停止轮询
    clearTimeout(timeout)
  },
  methods: {
    // 获取mqtt信息
    getMessage(res){
      // alert(res)
      console.log('mqtt返回信息',res)
      let vm = this
      // type信息类型：identityCheck为身份认证， exp为扫描快递单号
      if (res.type === 'identityCheck') {
        if (res.meta.code === 200) {
          console.log('验证成功', res)
          // 获取保存apitoken
          vm.$store.state.apitoken = res.data.apitoken
          // 保存用户id和验证方式
          // vm.$store.state.deliverData.user_id = res.data.user_id
          vm.$store.state.delivererUserId = res.data.user_id
          vm.$store.state.deliverData.deliver_way = res.data.way
          vm.$store.state.type = res.data.user_type === 'admin' ? 'staff' : 'express'
          this.$router.push({
            // 你要跳转的地址
            path: '/turnoverCabinet/selectCell'
          })
        } else {
          showToast(res.meta.message)
        }
      }
    },
    // 获取小程序码
    async getQRCode () {
      let vm = this
      // zy表示周转柜身份验证
      let data = {
        mode: 'getUnlimited',
	      data: {
          page: 'pages/login/login',
    	    scene: vm.$store.state.company_ic + 'zy' + storage.localGetItem('device_no_id')
        },
        type: 'zy',
        device_no_id: storage.localGetItem('device_no_id')
      }

      let res = await cabinetApi.getQRCode(data)
      if (res.meta.code === 200) {
        this.QRurl = res.data.image_url
        console.log('res二维码生获取成功', res)
      } else {
        showToast('二维码获取失败')
        console.log('二维码获取失败', res)
      }
    },
    // 轮询查询存件登录信息---即操作用户的身份
    async getStoreLoginInfo () {
      let vm= this
      let data = {
        device_no_id: storage.localGetItem('device_no_id')
      }

      let res = await cabinetApi.getStoreLoginInfo(data)
      if (res.meta.code === 200) {
        console.log('验证成功', res)
        // 获取保存apitoken
        vm.$store.state.apitoken = res.data.apitoken
        // 保存用户id和验证方式
        // vm.$store.state.deliverData.user_id = res.data.user_id
        vm.$store.state.delivererUserId = res.data.user_id
        vm.$store.state.deliverData.deliver_way = res.data.deliver_way
        vm.$store.state.type = res.data.user_type === 'admin' ? 'staff' : 'express'
        this.$router.push({
          // 你要跳转的地址
          path: '/turnoverCabinet/selectCell'
        })
      } else {
        console.log('未验证')
        timeout = setTimeout(() => {
          vm.getStoreLoginInfo()
        }, 500)
      }
    },
    // 返回上一页 (首页)
    back () {
      this.$router.push('/turnoverCabinet')
    }
  },
  watch: {
    '$refs.userSaveFlow.id' (newVal) {
      console.log('tag', newVal)
    }
  }
}
</script>

<style scoped>
.selectWay{
  width: 100%;
}

.selectWay .way-list{
  width: 15.27rem;
  margin: 0.8rem auto 0;
}

.selectWay .way-list .flex{
  display: flex;
  justify-content: center;
}

.selectWay .way-list .list{
  /* width: 6.14rem; */
  width: 6.14rem;
  text-align: center;
}

.selectWay .way-list .list:first-child{
  margin-right: 1.47rem;
}

.selectWay .way-list .list .title{
  font-size: 0.45rem;
  font-weight: bold;
  line-height: 0.5rem;
  margin-bottom: 0.4rem;
}

.selectWay .way-list .list .detail{
  width: 100%;
  padding: 0 0.5rem;
  height: 3.85rem;
}

.selectWay .way-list .list .detail .left-bracket,
.selectWay .way-list .list .detail .right-bracket{
  float: left;
  width: 0.54rem;
  height: inherit;
  border: 0.04rem solid #ffffff;
}

.selectWay .way-list .list .detail .left-bracket{
  border-right: none;
}

.selectWay .way-list .list .detail .right-bracket{
  border-left: none;
}

.selectWay .way-list .list .detail .img{
  float: left;
  width: 2.52rem;
  height: 2.52rem;
  line-height: 2.52rem;
  margin: 0.66rem 0.77rem 0;
  font-size: 0.34rem;
  background-color: #fff;
}

.selectWay .way-list .list .detail .card img{
  width: 100%;
}

.selectWay .way-list .list .detail .code img{
  display: block;
  width: 2.52rem;
  height: 2.52rem;
  position: relative;
  z-index: 9999;
}

</style>



// WEBPACK FOOTER //
// src/components/turnoverCabinet/common/saveSelectWay.vue